module.exports = __webpack_public_path__ + "img/airzen-mobile.04772c9.png";